module.exports = __webpack_public_path__ + "img/Aviation_fre_1.3cf2fc09.jpg";